module.exports = __webpack_public_path__ + "img/11.a606bc5f.jpg";